export const ur = {
    "TRIGGER_LISTEN": "پیشگی کے لئے سننا",
    "ASSIST_EMPTY_MSG": "ایجنٹ اے آئی آپ کی گفتگو سن رہا ہے اور جب متحرک ہو جائے تو خودکار طور پر مدد کرنے کے لئے تیار ہے۔",
    "MYBOT_TRIGGET_LISTEN": "فی الحال کوئی فعال My Bot ٹاسک موجود نہیں ہے",
    "MYBOT_EMTPY_MSG": "My Bot پر ایک ٹاسک شروع کرنے کے لئے، تلاش کے ٹیب میں جائیں اور اپنی مطلوبہ ٹاسک کے لئے 'ایجنٹ کے ان پٹ کے ساتھ چلائیں' کا انتخاب کریں۔",
    "PROACTIVE_MODE": "پیشگی موڈ",
    "SETTINGS": "ترتیبات",
    "HELP_AND_SUPPORT": "مدد اور معاونت",
    "HELP": "مدد",
    "LANGUAGE": "زبان",
    "THEME": "تھیم",
    "AUTOMATIC": "خودکار",
    "DARK": "تاریک",
    "LIGHT": "روشن",
    "FILE_NAME":"فائل کا نام",
    "AUTO_SCROLL_TOOLTIP":"مدد ٹیب، میرا بوٹ اور ٹرانسکرپٹ ٹیب کے مواد کے خودکار اسکرولنگ کو کنٹرول کرتا ہے",
    "THEME_DESC": "یہ آپ کے نظام کے ڈیفالٹ موڈ کا استعمال کرے گا",
    "DOCUMENTATION": "دستاویزات",
    "DOC_DESC": "ہمارے تفصیلی دستاویزی مضامین چیک کریں۔",
    "FAQ_U": "اکثر پوچھے جانے والے سوالات",
    "FAQ_DESC": "ایجنٹ اے آئی کے بارے میں اکثر پوچھے جانے والے سوالات دیکھیں۔",
    "KORE_ACADEMY": "کور اکیڈمی",
    "KORE_ACA_DESC": "اکیڈمی کے کورسز کے ذریعے ایجنٹ اے آئی کے بارے میں مزید سیکھیں۔",
    "SEARCH": "تلاش کریں",
    "MY_BOT": "میرا بوٹ",
    "ASSIST": "مدد",
    "TAB_TEXT":"کوئی ٹیب فعال نہیں ہے! براہ کرم کم از کم ایک ٹیب فعال کریں",
    "TRANSCRIPT": "ترانکریپٹ",
    "HISTORY": "تاریخ",
    "STARTOVER": "پھر سے شروع کریں",
    "RESTART_INPUTS": "ریکارڈ شدہ ان پٹس کے ساتھ دوبارہ شروع کریں",
    "ASKCUSTOMER": "کسٹمر سے پوچھیں",
    "TELLCUSTOMER": "کسٹمر کو بتائیں",
    "WELCOME_MSG": "خوش آمدید پیغام",
    "TAP_SEARCH":"تلاش کے لیے ٹیپ کریں",
    "SEND": "بھیجیں",
    "SENT": "بھیج دیا گیا",
    "AWAITING": "جواب کا انتظار | جاری رکھنے کے لیے ٹائپ کریں",
    "OVERRIDE": "جاری رکھنے کے لیے ٹائپ کریں",
    "OVERRIDE_FILE": "جاری رکھنے کے لیے فائل منسلک کریں",
    "ACCEPT_RESPONSE": "جواب قبول کر لیا گیا",
    "AGENT_ENTERED": "ایجنٹ شامل ہوا",
    "EXPECTED_FORMAT": "متوقع شکل",
    "INPUT_VALUES": "ان پٹ کی قدریں",
    "RESTART": "دوبارہ شروع کریں",
    "START_OVER": "پھر سے شروع کریں",
    "RESTART_CAPTURE": "ریکارڈ شدہ ان پٹس کے ساتھ دوبارہ شروع کریں",
    "CANCEL": "منسوخ کریں",
    "INTERRUPT_DIALOG": "گفتگو کا کام منقطع ہوا",
    "RUN": "چلائیں",
    "RUN_AGENT": "ایجنٹ کے ان پٹس کے ساتھ چلائیں",
    "STEP": "مرحلہ",
    "DIALOG_TASK": "گفتگو کا کام",
    "FAQ": "اکثر پوچھے جانے والے سوالات",
    "SNIPPET": "جواب",
    "ARTICLE": "ویب صفحات",
    "FILE": "فائلیں",
    "SUGGESTED": "سفارش کردہ",
    "ALL_DIALOG": "تمام گفتگو کے کام",
    "DIALOG_TEXT": "گفتگو",
    "INTENT_IDENTIFIED": "کسٹمر کا بیان",
    "NOT_WHAT_LOOKING": "غلط تجویز؟",
    "BOT": "بوٹ",
    "CUSTOMER": "کسٹمر",
    "YOU": "آپ",
    "TERMINATE_CONV": "گفتگو کا کام ختم کریں",
    "TERMINATE_CONV_DESC": "کیا آپ واقعی گفتگو کا کام ختم کرنا چاہتے ہیں؟ ایجنٹ اے آئی مزید تجاویز نہیں دے سکے گا۔",
    "YES_TERMINATE": "ہاں، ختم کریں",
    "NO_CANCEL": "نہیں، منسوخ کریں",
    "OVERRIDE_CONTINUE": "اوور رائیڈ موڈ میں جاری رکھیں",
    "SUMMARY_TEXT": "خلاصہ",
    "SUBMIT": "جمع کرائیں",
    "INTERRUPT_OCCURED": "انقطاع واقع ہوا",
    "IDENTIFIED_INTENT": "شناخت کردہ نیت",
    "INTERRUPT_DESC": "یہ عمل آپ کے جاری گفتگو کے کام کو ختم کر دے گا۔",
    "ACCEPT_RUN": "قبول کریں اور چلائیں",
    "RUN_LATER": "بعد میں چلائیں",
    "KNOW_MORE": "زیادہ جانیں",
    "MORE_TEXT": "زیادہ",
    "LESS_TEXT": "کم",
    "VIEW_MORE": "زیادہ دیکھیں",
    "VIEW_LESS": "کم دیکھیں",
    "SHOW_MORE_FAQ": "زیادہ FAQs دکھائیں",
    "SHOW_LESS_FAQ": "کم FAQs دکھائیں",
    "SHOW_MORE_ARTICLE": "زیادہ ویب صفحات دکھائیں",
    "SHOW_LESS_ARTICLE": "کم ویب صفحات دکھائیں",
    "SHOW_MORE_SNIPPET": "زیادہ جوابات دکھائیں",
    "SHOW_LESS_SNIPPET": "کم جوابات دکھائیں",
    "SHOW_MORE_FILES": "زیادہ فائلیں دکھائیں",
    "SHOW_LESS_FILES": "کم فائلیں دکھائیں",
    "VIEW_ALL_DIALOG": "تمام گفتگوئیں دیکھیں",
    "VIEW_FEW_DIALOG": "چند گفتگوئیں دیکھیں",
    "HELP_FULL": "کیا یہ مددگار تھا؟",
    "THANKYOU": "شکریہ!",
    "EXPAND_MORE": "پھیلائیں / مزید",
    "CLOSE_TEXT": "بند کریں",
    "STARTED": "شروع ہوا",
    "ENDED": "ختم ہوا",
    "VIEW_FULL_ARTICLE": "ویب صفحہ دیکھیں",
    "VIEW_FULL_FILE": "فائل دیکھیں",
    "COPIED": "کاپی کر لیا گیا",
    "SENTI_ANALY": "احساس تجزیہ",
    "WRONG_SUGGESTION": "غلط تجویز",
    "INCORRECT_INTENT": "غلط نیت",
    "ACCIDENTAL_CLICK": "غلطی سے کلک",
    "TIME_TAKING": "وقت لگ رہا ہے",
    "OTHER": "دیگر",
    "PLAYBOOK_EMPTY_MSG": "پلے بک منتخب کریں",
    "PLAYBOOK_EMPTY_DESC": "ایجنٹ اے آئی پلے بک کو لوڈ نہیں کر سکتا کیونکہ تمام دستیاب پلے بکس متحرک ہیں۔ پلے بک تک رسائی کے لئے 'پلے بک منتخب کریں' پر کلک کریں",
    "STAGE": "مرحلہ",
    "PROCEED_TO_CLOSE": "بند کرنے کے لیے آگے بڑھیں",
    "RECOMENDED_PLAYBOOK": "تجویز کردہ پلے بک",
    "PRIMARY_SCRIPTS": "بنیادی اسکرپٹس",
    "DYNAMIC_SCRIPTS": "متحرک اسکرپٹس",
    "RESUME": "جاری رکھیں",
    "ENABLE_CLOSE": "بند کرنے کے مرحلے کو فعال کرنے کے لئے 'بند کریں' کے بٹن پر کلک کریں",
    "LIST_VIEW": "فہرست دیکھیں",
    "TERMINATE": "ختم کریں",
    "MINIMIZE": "کم کریں",
    "MAXIMIZE": "بڑھائیں",
    "NO_SEARCH_RESULT": "کوئی تلاش کا نتیجہ نہیں ملا",
    "SENTIMENT_AWAITING": "احساس کا انتظار ہے",
    "POSITIVE": "مثبت",
    "NEGATIVE": "منفی",
    "ASSOCIATED_WORK_NOTES": "ماضی کی حل کی نوٹس",
    "AGENT_JOINED_CONV": "ایجنٹ گفتگو میں شامل ہوا",
    "AUTOSCROLL_ASSIST": "معاونت کے مواد کو خودکار طور پر اسکرول کریں",
    "FILE_SIZE_MSG": "فائل کا سائز 25MB سے کم ہونا چاہیے۔ براہ کرم دوبارہ کوشش کریں۔",
    "OVERRIDE_BTN": "اوور رائیڈ",
    "CHOOSE_FILE": "فائل منتخب کریں",
    "SUMMARY_ERROR_TEXT": "معاف کیجئے، لیکن اس گفتگو کے لئے خلاصہ تیار کرنے میں ایک مسئلہ ہوا ہے۔ براہ کرم اپنا خلاصہ بنائیں۔",
    "ASK_A_QUESTION": "سوال پوچھیں",
    "COPY": "کاپی کریں",
    "PLAYBOOK": "پلے بک",
    "TELL_US_MORE": "ہمیں مزید بتائیں…",
    "THANKS_FEEDBACK": "آپ کی رائے کا شکریہ",
    "SOMETHING_WRONG": "کچھ غلط ہوا",
    "CLICK_ERROR_DETAILS": "خرابی کی تفصیلات دیکھنے کے لیے کلک کریں",
    "NO_ACTIVE_PLAYBOOK": "کوئی فعال پلے بک نہیں ہے",
    "REPHRASE_QUESTION": "کیا آپ اپنے سوال کو دوبارہ بیان کر سکتے ہیں یا کچھ اور پوچھ سکتے ہیں؟",
    "VIEW_FULL_ARTICLE_2": "مکمل مضمون دیکھیں",
    "VIEW_FULL_FILE_2": "مکمل فائل دیکھیں",
    "INTERNAL_INFO": "اندرونی معلومات",
    "SOURCES": "ذرائع",
    "CONVERSATION_SUMMARY": "گفتگو کا خلاصہ",
    "WAITING": "انتظار کر رہا ہوں",
    "WIDGET_DISABLED": "ویجیٹ غیر فعال ہے",
    "AI_SETTINGS_DISABLED": "AI کی ترتیبات غیر فعال ہیں! براہ کرم AI منتظم سے رابطہ کریں",
    "SERVER_CONNECTION_ERROR": "سرور سے جڑنے میں خرابی",
    "VIEW": "دیکھیں",
    "ATTACHMENT_INPUT": "منسلک ان پٹ",
    "TYPE_SUMMARY": "خلاصہ ٹائپ کریں",
    "BY":"کی طرف سے",
    GENERATE_SUMMARY: "خلاصہ بنائیں",
    PREV_SUMMARIES: "پہلے سے تیار کردہ خلاصے",
    DIALOG_WORKFLOWS: "ڈائیلاگ ورک فلوز",
    SHOW_ALL_DIALOG: "تمام ڈائیلاگ ٹاسک دکھائیں",
    SHOW_ALL_DIALOGS: "تمام ڈائیلاگز دکھائیں",
    CUSTOM_TAB: "کسٹم ٹیب",
    AGENT_INPUT: "ایجنٹ کا ان پٹ",
    CUSTOM_EMPTY_MSG: "فی الحال کوئی پلے بک فعال نہیں ہے",
    "CUSTOM_TAB_DESC" : "ورک فلو شروع کرنے کے لیے، فہرست میں سے نیچے دی گئی کسی ایک کو چلائیں",
    "SUBMIT_OVERALL_FEEDBACK" : "جمع کرائیں جمعی علاقہ",
    "FEEDBACK_POPUP_SUBTITLE" : "ویجیٹ اور اس کے فیچرز کے بارے میں آپ کا علاقہ",
    "FEEDBACK_SATISFIED" : "ساعد ہو",
    "FEEDBACK_UNSATISFIED" : "ساعد نہیں ہو",
    "FEEDBACK_PROVIDE_REASONS" : "مزید سیکھیں…",
    "FEEDBACK_TITLE" : "علاقہ",
    "AGENTIC_THINKING" : "سوچ رہا ہے",
    "AGENTIC_AGENT_TITLE" : "ایجنٹ",
    "AGENTIC_COPILOT_MODE_TITLE" : "ایجنٹک کوپائلٹ موڈ",
    "AGENTIC_SENDING_MESSAGE" : "بھیجا جا رہا ہے...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot آپ کی گفتگو کو فعال طور پر سن رہا ہے اور خودکار طور پر مدد کرنے کے لیے تیار ہے",
    "AGENTIC_SEARCH_RESULTS" : "ایجنٹ نتائج",
    "PAUSE_AUTO_SEND" : "خودکار بھیجنا روکیں",
    "PAUSE_AGENTIC" : "ایجنٹ روکیں",
    "RESUME_AGENTIC" : "ایجنٹ دوبارہ شروع کریں",
    "RESUME_AUTO_SEND" : "خودکار بھیجنا دوبارہ شروع کریں"
}